import { AutogenLayoutCarrierCallins } from "./autogen/AutogenLayoutCarrierCallins";

export class CarrierCallins extends AutogenLayoutCarrierCallins {

    override onLoad() {
    }
}
